export default __webpack_public_path__ + "f3aeb9b621a6862af42e7db72f65dcc8.svg";